module.exports = __webpack_public_path__ + "static/media/0021_IMG_LES_ENSEIGNES_LES_PAINS_LETTRE_A_LETTRE.6d1b5fff.png";